import { useRouteError } from 'react-router-dom'

import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

function ErrorHandler() {
  const error = useRouteError()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <h1>{t.mcOoops}</h1>
      <p>{t.mcErroreImprevisto}</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  )
}

export default ErrorHandler
